module.exports = __webpack_public_path__ + "static/media/support_gray.88fb6d32.svg";